import React from "react";
import { BsFillEmojiSmileFill } from "react-icons/bs";
const PostCards = ({ avatar, commentWriter, comment }) => {
  return (
    <div className="flex z-10">
      <img
        className="h-8 w-8 mr-2 object-contain rounded-full cursor-pointer"
        src={avatar}
      />
      <div>
        <p className="p-2 pb-4 rounded-xl w-auto h-auto text-gray-400 bg-[#3A3B3C] inline-flex flex-col relative">
          <span className="text-gray-400 font-medium text-sm">
            {commentWriter}
          </span>
          {comment}
          <span className="rounded-lg px-1 text-xs text-gray-200 absolute bottom-[-5px] right-[-5px] inline-flex justify-start items-center bg-gray-500">
            <BsFillEmojiSmileFill className="mr-1" /> 354
          </span>
        </p>
        <div className="my-2 text-gray-400 font-medium text-sm flex justify-start items-center">
          <button className="py-1 px-2 mr-2 rounded-md hover:bg-gray-500 hover:text-gray-200">
            Like
          </button>
          <button className="py-1 px-2 mr-2 rounded-md hover:bg-gray-500 hover:text-gray-200">
            Reply
          </button>{" "}
          <span className="py-1 px-2 mr-2">4h</span>
        </div>
      </div>
    </div>
  );
};

export default PostCards;
